import md5 from 'js-md5'
const APP_ID = 'wpgj001'
const KEY = '6B47Nv15q3EX'

function sorASCII(obj) {
  var arr = new Array()
  var num = 0
  for (var i in obj) {
    arr[num] = i
    num++
  }
  var sortArr = arr.sort()
  var sortObj = {}
  for (var i in sortArr) {
    sortObj[sortArr[i]] = obj[sortArr[i]]
  }
  return sortObj
}

export const MD5 = (obj = {}) => {
  obj.appid = APP_ID
  obj.key = KEY
  obj.timestamp = new Date().getTime()

  obj = sorASCII(obj)
  let str = ''
  for (let item of Object.entries(obj)) {
    if (str) {
      str = str + '&' + item[0] + '=' + item[1]
    } else {
      str = item[0] + '=' + item[1]
    }
  }
  // console.log(str.toUpperCase())
  return md5(str).toUpperCase()
}
